import Helper from './Helper';
import KonamiCode from 'konami-code';

class Konami {

	constructor() {
		let konami = new KonamiCode();


    this.colors = ["#55efc4", "#81ecec", "#74b9ff", "#a29bfe", "#a29bfe", "#dfe6e9", "#00b894", "#00cec9", "#00cec9", "#00cec9", "#0984e3", "#6c5ce7", "#ffeaa7", "#fab1a0", "#ff7675", "#fd79a8", "#fdcb6e", "#e17055", "#d63031", "#e84393"];



		konami.listen( () => {

      //var KICKASSVERSION='2.0';var s = document.createElement('script');s.type='text/javascript';document.body.appendChild(s);s.src='//hi.kickassapp.com/kickass.js';void(0);
			Helper.addClass(document.querySelector('body'), 'konami');

      let i = 0;

      document.addEventListener('mousemove', (e) => {
          let coordinates = this.findScreenCoords();

          i++;
          this.createDiv(coordinates.x, coordinates.y, i);

          //console.log(coordinates.x);
      });

		});
	}

  createDiv(x, y, i){
    document.querySelector('.dots').innerHTML += '<div id="dot-'+i+'" class="dot" style="box-shadow: 0 0 10px #fff; z-index: 500; margin-top: '+(Math.floor(Math.random() * (10 - -10 + 1)) + -10)+'px; margin-left: '+(Math.floor(Math.random() * (10 - -10 + 1)) + -10)+'px; background-color: '+this.colors[Math.floor(Math.random() * this.colors.length)]+'; height: '+Math.floor(Math.random() * 10)+'; width: '+Math.floor(Math.random() * 10)+'; position: fixed; top: '+y+'px; left: '+x+'"px></div>';
    setTimeout(() => { Helper.removeFromDom(document.querySelector('#dot-'+i)) }, 500);
  }

  findScreenCoords(mouseEvent){

    let c_return = new Object();


    if (mouseEvent)
    {
      //FireFox
      c_return.x = mouseEvent.clientX;
      c_return.y = mouseEvent.clientY;
    }
    else
    {
      //IE
      c_return.x = window.event.clientX;
      c_return.y = window.event.clientY;
    }

    return c_return;
  }



}
export default Konami;
